import api from "./api";

export const transferService = {
  // Transfer coins from shop to player
  transferToPlayer: async (data) => {
    const response = await api.post("/shop/transfer-to-player", data);
    return response.data;
  },

  // Get transfer and transaction history
  getTransferHistory: async () => {
    const response = await api.get("/reports/transactions");
    return response.data;
  }
};

export default transferService;
